export const MATCH_PATTERN = /^(?<groups>\d{1,3}(?:[. ,']?\d{3})*)(?:[,.](?<fraction>\d{1,2}))?$/;
export const CLEAN_PATTERN = /^([0-9]{1,3}(?:[. ,']?[0-9]{3})*)(?:[,.]([0-9]{1,2}))?$/;
